var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAttach(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.71973 11.8135L12.2499 7.1748",
    stroke: "#0A0A0A",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33363 3.49983L4.42546 8.50833C4.20675 8.72711 4.08388 9.0238 4.08388 9.33316C4.08388 9.64252 4.20675 9.93921 4.42546 10.158C4.64425 10.3767 4.94094 10.4996 5.2503 10.4996C5.55965 10.4996 5.85635 10.3767 6.07513 10.158L10.9833 5.14949C11.4207 4.71193 11.6665 4.11854 11.6665 3.49983C11.6665 2.88111 11.4207 2.28773 10.9833 1.85016C10.5457 1.41273 9.95235 1.16699 9.33363 1.16699C8.71491 1.16699 8.12153 1.41273 7.68396 1.85016L2.77521 6.85808C2.11878 7.51451 1.75 8.40482 1.75 9.33316C1.75 10.2615 2.11878 11.1518 2.77521 11.8082C3.43165 12.4647 4.32196 12.8335 5.2503 12.8335C6.17863 12.8335 7.06895 12.4647 7.72538 11.8082",
    stroke: "#0A0A0A",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttach);
export default __webpack_public_path__ + "static/media/attach.0aa7083acd259506f2caa3ed5cb69833.svg";
export { ForwardRef as ReactComponent };